import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Typography } from '../../../Typography';
import { SchemaCell } from '../cells/SchemaCell/SchemaCell';
import styles from '../table.module.scss';
export function nestedCardRows(param) {
    let { nested, mainColumn, valueField, now, cardTestId } = param;
    if (mainColumn == null) return [];
    return nested.map((row, index)=>({
            key: "nested-".concat(index),
            spaceBetween: true,
            testId: cardTestId && "".concat(cardTestId, "-nested-").concat(index),
            label: (labelClassName)=>/*#__PURE__*/ _jsx(Typography, {
                    as: "div",
                    className: "".concat(labelClassName, " ").concat(styles.nestedCardRow),
                    children: /*#__PURE__*/ _jsx(SchemaCell, {
                        column: mainColumn,
                        row: row,
                        now: now,
                        testId: cardTestId && "".concat(cardTestId, "-nested-").concat(index, "-name")
                    })
                }),
            value: (valueClassName)=>valueField == null ? null : /*#__PURE__*/ _jsx("div", {
                    className: valueClassName,
                    children: /*#__PURE__*/ _jsx(SchemaCell, {
                        skin: "secondary",
                        column: valueField.column,
                        row: row,
                        now: now,
                        testId: cardTestId && "".concat(cardTestId, "-nested-").concat(index, "-value")
                    })
                })
        }));
}
export function withNestedRows(param) {
    let { own, nested } = param;
    return nested.length === 0 ? own : [
        ...own.slice(0, 1),
        ...nested,
        ...own.slice(1)
    ];
}
